import {
  Dialog,
  DialogTitle,
  Grid,
  Paper,
  styled,
  Table,
  TableBody,
  TableCell,
  tableCellClasses,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  Typography,
} from "@mui/material";
import React, { useState } from "react";
import { Button, Col, Form, Row } from "react-bootstrap";
import Home from "../../home/Home";
import { getDate } from "../../Utils/Common";
import BillingReportsService from "../../../Services/Reports/BillingReportsService";
import { useEffect } from "react";
import Snackbar from "../../Snacbar";
import HashLoader from "react-spinners/HashLoader";

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: "rgb(61, 195, 177)",
    color: "black",
    textAlign: "center",
    fontFamily: "Times New Roman",
    fontWeight: "bold",
  },
  [`&.${tableCellClasses.body}`]: {
    textAlign: "center",
    fontSize: 14,
    fontFamily: "Times New Roman",
  },
}));
const StyledTableRow = styled(TableRow)(({ theme }) => ({
  "&:nth-of-type(odd)": {
    backgroundColor: theme.palette.action.hover,
  },
}));
const ItemPap = styled(Paper)(({ theme }) => ({
  padding: theme.spacing(1),
  textAlign: "center",
  color: theme.palette.text.secondary,
  border: " 1px solid black",
  backgroundColor: "white",
  height: "100%",
}));
const ItemPap1 = styled(Paper)(({ theme }) => ({
  padding: theme.spacing(1),
  textAlign: "center",
  color: theme.palette.text.secondary,
  backgroundColor: "white",
  height: "100",
  border: "1px solid black",
}));
function BillSummaryReport() {
  const mystyle = {
    border: " 1px solid black",
    width: "9rem",
    fontFamily: "Times New Roman",
  };
  const mystyle1 = {
    fontWeight: "bolder",
    color: "#0b64c5",
    fontFamily: "Times New Roman",
  };

  const [message, setMessage] = useState("");
  const [open, setOpen] = useState(false);
  const [severit, setseverit] = useState("");
  const [FilteredDetails, setFilteredDetails] = useState([]);
  const [loading, setloading] = useState(false);
  const [details1, setdetails1] = useState([]);
  const [details2, setdetails2] = useState([]);
  const [details3, setdetails3] = useState([]);
  const [details4, setdetails4] = useState([]);
  const [details5, setdetails5] = useState([]);
  const [details6, setdetails6] = useState([]);
  const [singlejobsummaryOpen, setsinglejobsummaryOpen] = useState(false);
  const [billsumValues, setbillsumValues] = useState({
    from: getDate(),
    to: getDate(),
    job: "",
    impnm: "-1",
    fwnm: "-1",
    billby: "-1",
    billto: "",
    ///summary
    totalJobNo: "0",
    taxablevalue: "0.00",
    cgstAmt: "0.00",
    sgstAmt: "0.00",
    igstAmt: "0.00",
    totalBillAmt: "0.00",
  });
  const [BillSumDialog_values, setBillSumDialog_values] = useState({
    ///singlejobsummaryvalues
    dia_taxablevalue: "0.00",
    dia_sgstAmt: "0.00",
    dia_cgstAmt: "0.00",
    dia_igstAMt: "0.00",
    dia_totalBillAmt: "0.00",
  });

  const fromhandlechange = (e) => {
    setbillsumValues({ ...billsumValues, from: e.target.value });
  };
  const tohandlechange = (e) => {
    setbillsumValues({ ...billsumValues, to: e.target.value });
  };
  const impnmhandlechange = (e) => {
    setbillsumValues({
      ...billsumValues,
      impnm: e.target.value.replace(/[`~!@#$%^?'"<>]/gi, ""),
    });
  };
  const jobhandlechange = (e) => {
    setbillsumValues({
      ...billsumValues,
      job: e.target.value.replace(/[`~!@#$%^?'"<>]/gi, ""),
    });
  };
  const fwnmhandlechange = (e) => {
    setbillsumValues({
      ...billsumValues,
      fwnm: e.target.value.replace(/[`~!@#$%^?'"<>]/gi, ""),
    });
  };
  const billbyhandlechange = (e) => {
    setbillsumValues({
      ...billsumValues,
      billby: e.target.value.replace(/[`~!@#$%^?'"<>]/gi, ""),
    });
  };
  const billtohandlechange = (e) => {
    setbillsumValues({
      ...billsumValues,
      billto: e.target.value.replace(/[`~!@#$%^?'"<>]/gi, ""),
    });
  };
  //
  const [showProcs, setshowProcs] = useState(false);
  const [refreshProcs, setrefreshProcs] = useState(false);
  const [reportProcs, setreportProcs] = useState(false);
  ///clear summary
  const clearsummary = () => {
    setbillsumValues({
      ...billsumValues,
      totalJobNo: "0",
      taxablevalue: "0.00",
      cgstAmt: "0.00",
      sgstAmt: "0.00",
      igstAmt: "0.00",
      totalBillAmt: "0.00",
    });
  };
  ///clearsibgleSummaryvalues
  const clearsingleJobsummary = () => {
    setBillSumDialog_values({
      ...BillSumDialog_values,
      dia_cgstAmt: "0.00",
      dia_igstAMt: "0.00",
      dia_sgstAmt: "0.00",
      dia_taxablevalue: "0.00",
      dia_totalBillAmt: "0.00",
    });
  };

  ///dialogBox
  const handleClose = () => {
    setOpen(false);
  };
  const Singlejobsummaryopen = () => {
    setsinglejobsummaryOpen(true);
  };
  const Singlejobsummaryclose = () => {
    setsinglejobsummaryOpen(false);
  };
  ///getFunctions
  const getImporterDetails = () => {
    BillingReportsService.getImporterDetail().then((res) => {
      setdetails1(res.data);
    });
  };
  const getforwarderName = () => {
    BillingReportsService.selectFwdDetails().then((res) => {
      setdetails2(res.data);
    });
  };
  const getbillpaidby = () => {
    BillingReportsService.selectBillPaidBy().then((res) => {
      setdetails3(res.data);
    });
  };
  const getBillPaidToSelective = () => {
    BillingReportsService.getBillPaidTo().then((res) => {
      setdetails4(res.data);
    });
  };
  ///
  const SinglejobsummaryAssign = (trns) => {
    Singlejobsummaryopen();
    clearsingleJobsummary();
    let details = { consignmentId: trns.consignmentId };
    BillingReportsService.reportJobDetails(details).then((res) => {
      const data = res.data;
      const details = data.map((item) => item);
      var taxableValue = 0,
        cgstAmt = 0,
        sgstAmt = 0,
        igstAmt = 0,
        totaAmt = 0;
      for (let i = "0"; i < details.length; i++) {
        taxableValue += details[i].billAmount;
        cgstAmt += details[i].cgstAmt;
        sgstAmt += details[i].sgstAmt;
        igstAmt += details[i].igstAmt;
        totaAmt = taxableValue + igstAmt;
      }
      setBillSumDialog_values({
        ...BillSumDialog_values,
        dia_taxablevalue: taxableValue.toFixed(2),
        dia_sgstAmt: sgstAmt.toFixed(2),
        dia_cgstAmt: cgstAmt.toFixed(2),
        dia_igstAMt: igstAmt.toFixed(2),
        dia_totalBillAmt: totaAmt.toFixed(2),
      });
      setdetails6(res.data);
    });
  };
  ///Buttons Operation
  const showBtnClick = () => {
    setshowProcs(true);
    setloading(true);
    setPage(0);
    clearsummary();
    clearsingleJobsummary();
    var billTo,
      jobNo = "";
    if (
      billsumValues.job === "" ||
      billsumValues.job === null ||
      !billsumValues.job
    ) {
      jobNo = "-1";
    } else {
      jobNo = billsumValues.job;
    }
    if (billsumValues.billto === "FORWARDER") {
      billTo = "2";
    } else if (billsumValues.billto === "IMPORTER") {
      billTo = "1";
    } else {
      billTo = "-1";
    }
    let details = {
      fromDate: billsumValues.from,
      toDate: billsumValues.to,
      consignmentId: jobNo,
      iecNo: billsumValues.impnm,
      fwdcode: billsumValues.fwnm,
      billPaidBy: billsumValues.billby,
      billPaidTo: billTo,
    };
    BillingReportsService.reportBillingSummary(details).then((res) => {
      const data = res.data;
      const details = data.map((item) => item);
      if (details[0] === [] || !details[0]) {
        setMessage("No Data Found!!");
        setseverit("warning");
        setOpen(true);
        setloading(false);
        setshowProcs(false);
      } else {
        var totaljob = 0,
          valueTaxableAmount = 0,
          valueCGSTamount = 0,
          valueSGSTamount = 0,
          valueIGSTamount = 0,
          valueTotalBillAmount = 0;
        var jobCount = 0;
        var valueJob = "";
        for (let i = 0; i < details.length; i++) {
          if (details[i].consignmentId !== valueJob) {
            jobCount += 1;
            valueJob = details[i].consignmentId;
          }
          totaljob = jobCount;
          valueTaxableAmount = valueTaxableAmount + details[i].billAmount;
          valueCGSTamount += details[i].cgstAmt;
          valueSGSTamount += details[i].sgstAmt;
          valueIGSTamount += details[i].igstAmt;
          valueTotalBillAmount += details[i].totalBillAmount;
        }

        setbillsumValues({
          ...billsumValues,
          totalJobNo: totaljob,
          taxablevalue: valueTaxableAmount.toFixed(2),
          cgstAmt: valueCGSTamount.toFixed(2),
          sgstAmt: valueSGSTamount.toFixed(2),
          igstAmt: valueIGSTamount.toFixed(2),
          totalBillAmt: valueTotalBillAmount.toFixed(2),
        });
        setdetails5(res.data);
        setFilteredDetails(res.data);
        setloading(false);
        setshowProcs(false);
      }
    });
  };
  const RefreshBtnClick = () => {
    setrefreshProcs(true);
    setPage(0);
    setbillsumValues({
      ...billsumValues,
      from: getDate(),
      to: getDate(),
      job: "",
      impnm: "-1",
      fwnm: "-1",
      billby: "-1",
      billto: "",
      totalJobNo: "0",
      taxablevalue: "0.00",
      cgstAmt: "0.00",
      sgstAmt: "0.00",
      igstAmt: "0.00",
      totalBillAmt: "0.00",
    });
    setdetails5([]);
    setFilteredDetails([]);
    setshowProcs(false);
    setrefreshProcs(false);
  };
  const reportBtnClick = () => {
    setreportProcs(true);
    if (!details5[0]) {
      setMessage("No Record Found");
      setseverit("warning");
      setOpen(true);
    } else {
      var tableContent,
        contenall = "";
      for (let i = 0; i < details5.length; i++) {
        if (details5[i].consignmentId !== "") {
          tableContent = details5[i].consignmentId + "!";
        } else {
          tableContent += "   !";
        }
        if (details5[i].invoiceNo !== "") {
          tableContent += details5[i].invoiceNo + "!";
        } else {
          tableContent += "  !";
        }
        if (details5[i].invoiceDate !== "") {
          tableContent += details5[i].invoiceDate + "!";
        } else {
          tableContent += "  !";
        }
        if (details5[i].iecName !== "") {
          tableContent += details5[i].iecName + "!";
        } else {
          tableContent += "  !";
        }
        if (details5[i].fwdName !== "") {
          tableContent += details5[i].fwdName + "!";
        } else {
          tableContent += "  !";
        }
        if (details5[i].partyName !== "") {
          tableContent += details5[i].partyName + "!";
        } else {
          tableContent += "  !";
        }
        if (details5[i].partyGstin !== "") {
          tableContent += details5[i].partyGstin + "!";
        } else {
          tableContent += "  !";
        }
        if (details5[i].partyStateCode !== "") {
          tableContent += details5[i].partyStateCode + "!";
        } else {
          tableContent += "  !";
        }
        if (details5[i].transitMode !== "") {
          tableContent += details5[i].transitMode + "!";
        } else {
          tableContent += "  !";
        }
        if (details5[i].mawbNo !== "") {
          tableContent += details5[i].mawbNo + "!";
        } else {
          tableContent += "  !";
        }
        if (details5[i].hawbNo !== "") {
          tableContent += details5[i].hawbNo + "!";
        } else {
          tableContent += "  !";
        }
        if (details5[i].containerNo !== "") {
          tableContent += details5[i].containerNo + "!";
        } else {
          tableContent += "  !";
        }
        if (details5[i].noOfPkg !== "") {
          tableContent += details5[i].noOfPkg + "!";
        } else {
          tableContent += "  !";
        }
        if (details5[i].grNetWeight !== "") {
          tableContent += details5[i].grNetWeight + "!";
        } else {
          tableContent += "  !";
        }
        if (details5[i].billPaidBy !== "") {
          tableContent += details5[i].billPaidBy + "!";
        } else {
          tableContent += "  !";
        }
        if (details5[i].billPaidDate !== "") {
          tableContent += details5[i].billPaidDate + "!";
        } else {
          tableContent += "  !";
        }
        if (details5[i].billAmount !== "") {
          tableContent += details5[i].taxableValue + "!";
        } else {
          tableContent += "  !";
        }
        if (details5[i].cgstAmt !== "") {
          tableContent += details5[i].cgstAmt + "!";
        } else {
          tableContent += "  !";
        }
        if (details5[i].sgstAmt !== "") {
          tableContent += details5[i].sgstAmt + "!";
        } else {
          tableContent += "  !";
        }
        if (details5[i].igstAmt !== "") {
          tableContent += details5[i].igstAmt + "!";
        } else {
          tableContent += "  !";
        }
        if (details5[i].totalBillAmount !== "") {
          tableContent += details5[i].totalBillAmount + "!";
        } else {
          tableContent += "  !";
        }
        if (details5[i].boeNo !== "") {
          tableContent += details5[i].boeNo + "!";
        } else {
          tableContent += "  !";
        }
        if (details5[i].partyCode !== "") {
          tableContent += details5[i].partyCode + "!";
        } else {
          tableContent += "  !";
        }
        if (details5[i].auditStatus !== "") {
          tableContent += details5[i].auditStatus + "!";
        } else {
          tableContent += "  !";
        }
        if (details5[i].itemName !== "") {
          tableContent += details5[i].itemName + "!";
        } else {
          tableContent += "  !";
        }
        if (details5[i].chargableWeight !== "") {
          tableContent += details5[i].chargableWeight + "!";
        } else {
          tableContent += "  !";
        }
        if (details5[i].assableValue !== "") {
          tableContent += details5[i].assableValue + "#";
        } else {
          tableContent += "  #";
        }
        contenall += tableContent;
      }
      // console.log('contenall => '+JSON.stringify(contenall))
      let details = {
        headerName: "3,0,DAILY BILL SUMMARY REPORT",
        headerDetails:
          "1,1,FROM DATE : " +
          billsumValues.from +
          "/4,1,TO DATE : " +
          billsumValues.to,
        tableHeader:
          "0,3,Sl.No/1,3,Job No/2,3,Invoice No/3,3,Invoice Date/4,3,Importer Name/5,3,Forwarder Name/6,3,Party Name/7,3,Party Gstin/8,3,Party State/9,3,Mode/10,3,MAWB OR MBL NO/11,3,HAWB OR HBL/12,3,Container No/13,3,Total PKG/14,3,Total Weight/15,3,Bill Paid By/16,3,Bill Paid Date/17,3,Taxable Value/18,3,CGST Amount/19,3,SGST Amount/20,3,IGST Amount/21,3,Total Bill Amount/22,3,Boe No/23,3,Party Code/24,3,Audit Status/25,3,Item Description/26,3,Chargeable Weight/27,3,Assessable value",
        tableRowStartsFrom: 4,
        tableColumnStartsFrom: 0,
        fileCode: "dsd",
        totalNumberOfColumn: 27,
        tableContent: contenall.substring(0, contenall.length - 1),
      };
      BillingReportsService.Excelwrite(details).then((res) => {
        const filename = res.data.message;
        // window.open('http://localhost:8080/ExportFiles/' + filename.toString(), "_blank")
        window.open(
          "http://35.154.221.117:8081/ExportFiles/" + filename.toString(),
          "_blank"
        );
      });
    }
    setreportProcs(false);
  };
  const ReportClick = () => {
    if (!details6[0]) {
      setMessage("No Record Found");
      setseverit("warning");
      setOpen(true);
    } else {
      var tableContent,
        contenall = "";
      for (let i = 0; i < details6.length; i++) {
        if (details6[i].consignmentId !== "") {
          tableContent = details6[i].consignmentId + "!";
        } else {
          tableContent += "   !";
        }
        if (details6[i].billName !== "") {
          tableContent += details6[i].billName + "!";
        } else {
          tableContent += "  !";
        }
        if (details6[i].hsnCode !== "") {
          tableContent += details6[i].hsnCode + "!";
        } else {
          tableContent += "  !";
        }
        if (details6[i].billAmount !== "") {
          tableContent += details6[i].billAmount + "!";
        } else {
          tableContent += "  !";
        }
        if (details6[i].cgstRate !== "") {
          tableContent += details6[i].cgstRate + "!";
        } else {
          tableContent += "  !";
        }
        if (details6[i].cgstAmt !== "") {
          tableContent += details6[i].cgstAmt + "!";
        } else {
          tableContent += "  !";
        }
        if (details6[i].sgstRate !== "") {
          tableContent += details6[i].profitAmt + "!";
        } else {
          tableContent += "  !";
        }
        if (details6[i].sgstAmt !== "") {
          tableContent += details6[i].sgstAmt + "!";
        } else {
          tableContent += "  !";
        }
        if (details6[i].igstRate !== "") {
          tableContent += details6[i].igstRate + "!";
        } else {
          tableContent += "  !";
        }
        if (details6[i].igstAmt !== "") {
          tableContent += details6[i].igstAmt + "!";
        } else {
          tableContent += "  !";
        }
        if (details6[i].totalBillAmount !== "") {
          tableContent += details6[i].totalBillAmount + "#";
        } else {
          tableContent += "  #";
        }
        contenall += tableContent;
      }
      // console.log('contenall => '+JSON.stringify(contenall))
      let details = {
        headerName: "3,0,DAILY BILL DETAILS REPORT",
        headerDetails:
          "1,1,FROM DATE : " +
          BillSumDialog_values.from +
          "/4,1,TO DATE : " +
          BillSumDialog_values.to,
        tableHeader:
          "0,3,Sl.No/1,3,Job No/2,3,Description/3,3,HSN Code/4,3,Taxable Value/5,3,CGST Rate/6,3,CGST Amount/7,3,SGST Rate/8,3,SGST Amount/9,3,IGST Rate/10,3,IGST Amount/11,3,Total Bill Amount",
        tableRowStartsFrom: 4,
        tableColumnStartsFrom: 0,
        fileCode: "dbd",
        totalNumberOfColumn: 12,
        tableContent: contenall.substring(0, contenall.length - 1),
      };
      BillingReportsService.Excelwrite(details).then((res) => {
        const filename = res.data.message;
        // window.open('http://localhost:8080/ExportFiles/' + filename.toString(), "_blank")
        window.open(
          "http://35.154.221.117:8081/ExportFiles/" + filename.toString(),
          "_blank"
        );
      });
    }
  };

  useEffect(() => {
    setloading(true);
    setTimeout(() => {
      setloading(false);
    }, 1000);
    getImporterDetails();
    getforwarderName();
    getbillpaidby();
    getBillPaidToSelective();
  }, []);

  const jobnoSrch = () => {
    return (
      <input
        style={{ width: "60px", textAlign: "center", fontSize: "12px" }}
        placeholder="Search"
        onChange={(e) => {
          jobNoOnchange(e.target.value);
        }}
      />
    );
  };
  const invoiceNoSrch = () => {
    return (
      <input
        placeholder="Search"
        style={{ width: "60px", textAlign: "center", fontSize: "12px" }}
        onChange={(e) => {
          invoiceNoOnchange(e.target.value);
        }}
      />
    );
  };
  const impNameSrch = () => {
    return (
      <input
        placeholder="Search"
        style={{ width: "60px", textAlign: "center", fontSize: "12px" }}
        onChange={(e) => {
          impnameOnchange(e.target.value);
        }}
      />
    );
  };
  const forwarderNmSrch = () => {
    return (
      <input
        placeholder="Search"
        style={{ width: "60px", textAlign: "center", fontSize: "12px" }}
        onChange={(e) => {
          forwarderNmOnchange(e.target.value);
        }}
      />
    );
  };
  const partyNameSrch = () => {
    return (
      <input
        placeholder="Search"
        style={{ width: "60px", textAlign: "center", fontSize: "12px" }}
        onChange={(e) => {
          partynameOnchange(e.target.value);
        }}
      />
    );
  };
  const partystateSrch = () => {
    return (
      <input
        placeholder="Search"
        style={{ width: "60px", textAlign: "center", fontSize: "12px" }}
        onChange={(e) => {
          partystateOnchange(e.target.value);
        }}
      />
    );
  };
  const containerSrch = () => {
    return (
      <input
        placeholder="Search"
        style={{ width: "60px", textAlign: "center", fontSize: "12px" }}
        onChange={(e) => {
          containerOnchange(e.target.value);
        }}
      />
    );
  };

  const jobNoOnchange = (searchedVal) => {
    const filteredvalue = details5.filter((trns) => {
      return trns.consignmentId
        .toString()
        .toLowerCase()
        .includes(searchedVal.toLowerCase());
    });
    if (filteredvalue.length < 1) {
      setFilteredDetails(details5);
    } else {
      setFilteredDetails(filteredvalue);
    }
  };
  const invoiceNoOnchange = (searchedVal) => {
    const filteredvalue = details5.filter((trns) => {
      return trns.invoiceNo
        .toString()
        .toLowerCase()
        .includes(searchedVal.toLowerCase());
    });
    if (filteredvalue.length < 1) {
      setFilteredDetails(details5);
    } else {
      setFilteredDetails(filteredvalue);
    }
  };
  const impnameOnchange = (searchedVal) => {
    const filteredvalue = details5.filter((trns) => {
      return trns.iecName
        .toString()
        .toLowerCase()
        .includes(searchedVal.toLowerCase());
    });
    if (filteredvalue.length < 1) {
      setFilteredDetails(details5);
    } else {
      setFilteredDetails(filteredvalue);
    }
  };
  const forwarderNmOnchange = (searchedVal) => {
    const filteredvalue = details5.filter((trns) => {
      return trns.fwdName
        .toString()
        .toLowerCase()
        .includes(searchedVal.toLowerCase());
    });
    if (filteredvalue.length < 1) {
      setFilteredDetails(details5);
    } else {
      setFilteredDetails(filteredvalue);
    }
  };
  const partynameOnchange = (searchedVal) => {
    const filteredvalue = details5.filter((trns) => {
      return trns.partyName
        .toString()
        .toLowerCase()
        .includes(searchedVal.toLowerCase());
    });
    if (filteredvalue.length < 1) {
      setFilteredDetails(details5);
    } else {
      setFilteredDetails(filteredvalue);
    }
  };
  const partystateOnchange = (searchedVal) => {
    const filteredvalue = details5.filter((trns) => {
      return trns.partyStateCode
        .toString()
        .toLowerCase()
        .includes(searchedVal.toLowerCase());
    });
    if (filteredvalue.length < 1) {
      setFilteredDetails(details5);
    } else {
      setFilteredDetails(filteredvalue);
    }
  };
  const containerOnchange = (searchedVal) => {
    const filteredvalue = details5.filter((trns) => {
      return trns.containerNo
        .toString()
        .toLowerCase()
        .includes(searchedVal.toLowerCase());
    });
    if (filteredvalue.length < 1) {
      setFilteredDetails(details5);
    } else {
      setFilteredDetails(filteredvalue);
    }
  };
  //paginationCodes

  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };
  return (
    <div>
      <Home />
      <div>
        <Snackbar
          open={open}
          message={message}
          severity={severit}
          onClose={handleClose}
        />
        {/* //singlejob_summarydialogbox */}
        <Dialog
          open={singlejobsummaryOpen}
          onClose={Singlejobsummaryclose}
          maxWidth
        >
          <DialogTitle className="bg-info p-1">
            <center>Bill details</center>
          </DialogTitle>
          <div>
            <ItemPap>
              <lable
                style={{ fontSize: "18px", fontWeight: "bold", color: "red" }}
              >
                Summary
              </lable>
              <Row>
                <Col>
                  <Form.Label
                    style={{
                      fontFamily: "Times New Roman",
                      color: "black",
                      fontWeight: "bolder",
                    }}
                  >
                    Taxable Value :
                  </Form.Label>
                  <Form.Label
                    style={{
                      fontFamily: "Times New Roman",
                      color: "red",
                      fontWeight: "bolder",
                    }}
                  >
                    {BillSumDialog_values.dia_taxablevalue}
                  </Form.Label>
                </Col>

                <Col>
                  <Form.Label
                    style={{
                      fontFamily: "Times New Roman",
                      color: "black",
                      fontWeight: "bolder",
                    }}
                  >
                    SGST Amount :
                  </Form.Label>
                  <Form.Label
                    style={{
                      fontFamily: "Times New Roman",
                      color: "red",
                      fontWeight: "bolder",
                    }}
                  >
                    {BillSumDialog_values.dia_sgstAmt}
                  </Form.Label>
                </Col>
              </Row>
              <Row>
                <Col>
                  <Form.Label
                    style={{
                      fontFamily: "Times New Roman",
                      color: "black",
                      fontWeight: "bolder",
                    }}
                  >
                    CGST Amount :
                  </Form.Label>
                  <Form.Label
                    style={{
                      fontFamily: "Times New Roman",
                      color: "red",
                      fontWeight: "bolder",
                    }}
                  >
                    {BillSumDialog_values.dia_cgstAmt}
                  </Form.Label>
                </Col>

                <Col>
                  <Form.Label
                    style={{
                      fontFamily: "Times New Roman",
                      color: "black",
                      fontWeight: "bolder",
                    }}
                  >
                    IGST Amount :
                  </Form.Label>
                  <Form.Label
                    style={{
                      fontFamily: "Times New Roman",
                      color: "red",
                      fontWeight: "bolder",
                    }}
                  >
                    {BillSumDialog_values.dia_igstAMt}
                  </Form.Label>
                </Col>
              </Row>
              <Row>
                <Col>
                  <Form.Label
                    style={{
                      fontFamily: "Times New Roman",
                      color: "black",
                      fontWeight: "bolder",
                    }}
                  >
                    Total Bill Amount :
                  </Form.Label>
                  <Form.Label
                    style={{
                      fontFamily: "Times New Roman",
                      color: "red",
                      fontWeight: "bolder",
                    }}
                  >
                    {BillSumDialog_values.dia_totalBillAmt}
                  </Form.Label>
                </Col>
              </Row>
              <Button
                style={{ fontFamily: "Times New Roman" }}
                className="mt-1 mb-1"
                variant="success"
                size="sm"
                onClick={ReportClick}
              >
                {" "}
                Report{" "}
              </Button>
              <TableContainer
                sx={{ height: "220px" }}
                className="scrollbarPrime"
              >
                <Table
                  stickyHeader
                  className="table table-bordered-dark border-dark table table-bordered"
                >
                  <TableHead>
                    <StyledTableRow>
                      <StyledTableCell style={{ textAlign: "center" }}>
                        Sl.No
                      </StyledTableCell>
                      <StyledTableCell style={{ textAlign: "center" }}>
                        JobNo
                      </StyledTableCell>
                      <StyledTableCell style={{ textAlign: "center" }}>
                        Description
                      </StyledTableCell>
                      <StyledTableCell style={{ textAlign: "center" }}>
                        HSN_Code
                      </StyledTableCell>
                      <StyledTableCell style={{ textAlign: "center" }}>
                        TaxableValue
                      </StyledTableCell>
                      <StyledTableCell style={{ textAlign: "center" }}>
                        CGSTRate
                      </StyledTableCell>
                      <StyledTableCell style={{ textAlign: "center" }}>
                        CGSTAmount
                      </StyledTableCell>
                      <StyledTableCell style={{ textAlign: "center" }}>
                        {" "}
                        SGST_RATE
                      </StyledTableCell>
                      <StyledTableCell style={{ textAlign: "center" }}>
                        SGST_Amount
                      </StyledTableCell>
                      <StyledTableCell style={{ textAlign: "center" }}>
                        IGST_Rate
                      </StyledTableCell>
                      <StyledTableCell style={{ textAlign: "center" }}>
                        IGST_Amount
                      </StyledTableCell>
                      <StyledTableCell style={{ textAlign: "center" }}>
                        TotalBillAmount
                      </StyledTableCell>
                    </StyledTableRow>
                  </TableHead>
                  <TableBody>
                    {details6.map((trns) => (
                      <StyledTableRow hover>
                        <StyledTableCell style={{ fontSize: "11px" }}>
                          {trns.serialNumber}
                        </StyledTableCell>
                        <StyledTableCell style={{ fontSize: "11px" }}>
                          {trns.consignmentId}
                        </StyledTableCell>
                        <StyledTableCell style={{ fontSize: "11px" }}>
                          {trns.billName}
                        </StyledTableCell>
                        <StyledTableCell style={{ fontSize: "11px" }}>
                          {trns.hsnCode}
                        </StyledTableCell>
                        <StyledTableCell style={{ fontSize: "11px" }}>
                          {trns.billAmount}
                        </StyledTableCell>
                        <StyledTableCell style={{ fontSize: "11px" }}>
                          {trns.cgstRate}
                        </StyledTableCell>
                        <StyledTableCell style={{ fontSize: "11px" }}>
                          {trns.cgstAmt}
                        </StyledTableCell>
                        <StyledTableCell style={{ fontSize: "11px" }}>
                          {trns.sgstRate}
                        </StyledTableCell>
                        <StyledTableCell style={{ fontSize: "11px" }}>
                          {trns.sgstAmt}
                        </StyledTableCell>
                        <StyledTableCell style={{ fontSize: "11px" }}>
                          {trns.igstRate}
                        </StyledTableCell>
                        <StyledTableCell style={{ fontSize: "11px" }}>
                          {trns.igstAmt}
                        </StyledTableCell>
                        <StyledTableCell style={{ fontSize: "11px" }}>
                          {trns.totalBillAmount}
                        </StyledTableCell>
                      </StyledTableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            </ItemPap>
          </div>
        </Dialog>
      </div>
      {/* ////design... */}
      <div style={{ paddingLeft: "80px" }}>
        {loading ? (
          <div className="loaderCss">
            <HashLoader
              color={"#296cbc"}
              loading={loading}
              size={50}
              aria-label="Loading Spinner"
              data-testid="loader"
            />
          </div>
        ) : (
          <ItemPap>
            <Grid container>
              <Grid item xs={8}>
                <div
                  className="Billingtitleclr"
                  style={{
                    fontFamily: "Times New Roman",
                    color: "red",
                    fontWeight: "bold",
                    fontSize: "25px",
                    marginTop: "1%",
                    marginBottom: "1%",
                  }}
                >
                  <center>BILL SUMMARY REPORT</center>
                </div>
                <Row>
                  <Col xs={3}>
                    <label style={mystyle1}>From Date</label>
                  </Col>
                  <Col>
                    <Form.Control
                      size="sm"
                      type="date"
                      style={mystyle}
                      value={billsumValues.from}
                      onChange={fromhandlechange}
                    />
                  </Col>
                  <Col>
                    <label style={mystyle1}>To Date</label>
                  </Col>
                  <Col>
                    <Form.Control
                      size="sm"
                      type="date"
                      style={mystyle}
                      value={billsumValues.to}
                      onChange={tohandlechange}
                    />
                  </Col>
                </Row>
                <Row className="mt-1">
                  <Col xs={3}>
                    <label style={mystyle1}>Job No</label>
                  </Col>
                  <Col>
                    <Form.Control
                      size="sm"
                      type="text"
                      style={mystyle}
                      value={billsumValues.job}
                      onChange={jobhandlechange}
                    ></Form.Control>
                  </Col>
                  <Col>
                    <label style={mystyle1}>Importer Name</label>
                  </Col>
                  <Col>
                    <Form.Select
                      size="sm"
                      style={mystyle}
                      value={billsumValues.impnm}
                      onChange={impnmhandlechange}
                    >
                      <option value={"-1"}>ALL</option>
                      {details1.map((trns) => (
                        <option value={trns.importer_iec_no}>
                          {trns.importer_name}
                        </option>
                      ))}
                    </Form.Select>
                  </Col>
                </Row>
                <Row className="mt-1">
                  <Col xs={3}>
                    <label style={mystyle1}>Forwarder Name</label>
                  </Col>
                  <Col>
                    <Form.Select
                      size="sm"
                      style={mystyle}
                      value={billsumValues.fwnm}
                      onChange={fwnmhandlechange}
                    >
                      <option value={"-1"}>ALL</option>
                      {details2.map((trns) => (
                        <option value={trns.fwdcode}>{trns.fwdName}</option>
                      ))}
                    </Form.Select>
                  </Col>
                  <Col>
                    <label style={mystyle1}>Bill Paid By</label>
                  </Col>
                  <Col>
                    <Form.Select
                      size="sm"
                      style={mystyle}
                      value={billsumValues.billby}
                      onChange={billbyhandlechange}
                    >
                      <option value={"-1"}>ALL</option>
                      {details3.map((trns) => (
                        <option value={trns.billPaidBy}>
                          {trns.billPaidBy}
                        </option>
                      ))}
                    </Form.Select>
                  </Col>
                </Row>
                <Row className="mt-1">
                  <Col xs={3}>
                    <label style={mystyle1}>Bill Print To</label>
                  </Col>
                  <Col>
                    <Form.Select
                      size="sm"
                      style={mystyle}
                      value={billsumValues.billto}
                      onChange={billtohandlechange}
                    >
                      <option></option>
                      {details4.map((trns) => (
                        <option value={trns.billPaidTo}>
                          {trns.billPaidTo}
                        </option>
                      ))}
                    </Form.Select>
                  </Col>
                  <Col lg={4}></Col>
                </Row>
                <center>
                  <Col lg={5} className="mt-2">
                    <Button
                      variant="success"
                      style={{ fontFamily: "Times New Roman" }}
                      size="sm"
                      onClick={showBtnClick}
                    >
                      {showProcs ? "processing..." : "Show"}
                    </Button>{" "}
                    <Button
                      variant="warning"
                      style={{ fontFamily: "Times New Roman" }}
                      size="sm"
                      onClick={RefreshBtnClick}
                    >
                      {refreshProcs ? "processing..." : "Refresh"}
                    </Button>{" "}
                    <Button
                      variant="primary"
                      style={{ fontFamily: "Times New Roman" }}
                      size="sm"
                      onClick={reportBtnClick}
                    >
                      {reportProcs ? "processing..." : "Report"}{" "}
                    </Button>
                  </Col>
                </center>
              </Grid>
              <Grid item xs={4}>
                <ItemPap1>
                  <Typography
                    style={{ fontFamily: "Times New Roman" }}
                    color={"darkblue"}
                    fontWeight={"bolder"}
                    variant={"h6"}
                  >
                    {" "}
                    Summary{" "}
                  </Typography>
                  <Row>
                    <Col xs={3}>
                      <Form.Label
                        style={{
                          fontFamily: "Times New Roman",
                          justifyContent: "left",
                          color: "black",
                          fontWeight: "bolder",
                        }}
                      >
                        TotalJobNo
                      </Form.Label>
                    </Col>
                    <Col xs={3}>
                      <Form.Label
                        style={{
                          fontFamily: "Times New Roman",
                          justifyContent: "left",
                          color: "black",
                          fontWeight: "bolder",
                        }}
                      >
                        :
                      </Form.Label>
                    </Col>
                    <Col>
                      <Form.Label
                        style={{
                          justifyContent: "left",
                          color: "red",
                          fontWeight: "bolder",
                        }}
                      >
                        {billsumValues.totalJobNo}
                      </Form.Label>
                    </Col>
                  </Row>
                  <Row>
                    <Col xs={3}>
                      <Form.Label
                        style={{
                          fontFamily: "Times New Roman",
                          justifyContent: "left",
                          color: "black",
                          fontWeight: "bolder",
                        }}
                      >
                        TaxableValue
                      </Form.Label>
                    </Col>
                    <Col xs={3}>
                      <Form.Label
                        style={{
                          fontFamily: "Times New Roman",
                          justifyContent: "left",
                          color: "black",
                          fontWeight: "bolder",
                        }}
                      >
                        :
                      </Form.Label>
                    </Col>
                    <Col>
                      <Form.Label
                        style={{
                          fontFamily: "Times New Roman",
                          justifyContent: "left",
                          color: "red",
                          fontWeight: "bolder",
                        }}
                      >
                        {billsumValues.taxablevalue}
                      </Form.Label>
                    </Col>
                  </Row>
                  <Row>
                    <Col xs={3}>
                      <Form.Label
                        style={{
                          fontFamily: "Times New Roman",
                          justifyContent: "left",
                          color: "black",
                          fontWeight: "bolder",
                        }}
                      >
                        CGSTAmount
                      </Form.Label>
                    </Col>
                    <Col xs={3}>
                      <Form.Label
                        style={{
                          justifyContent: "left",
                          color: "black",
                          fontWeight: "bolder",
                        }}
                      >
                        :
                      </Form.Label>
                    </Col>
                    <Col>
                      <Form.Label
                        style={{
                          fontFamily: "Times New Roman",
                          justifyContent: "left",
                          color: "red",
                          fontWeight: "bolder",
                        }}
                      >
                        {billsumValues.cgstAmt}
                      </Form.Label>
                    </Col>
                  </Row>
                  <Row>
                    <Col xs={3}>
                      <Form.Label
                        style={{
                          fontFamily: "Times New Roman",
                          justifyContent: "left",
                          color: "black",
                          fontWeight: "bolder",
                        }}
                      >
                        SGSTAmount
                      </Form.Label>
                    </Col>
                    <Col xs={3}>
                      <Form.Label
                        style={{
                          justifyContent: "left",
                          color: "black",
                          fontWeight: "bolder",
                        }}
                      >
                        :
                      </Form.Label>
                    </Col>
                    <Col>
                      <Form.Label
                        style={{
                          fontFamily: "Times New Roman",
                          justifyContent: "left",
                          color: "red",
                          fontWeight: "bolder",
                        }}
                      >
                        {billsumValues.sgstAmt}
                      </Form.Label>
                    </Col>
                  </Row>
                  <Row>
                    <Col xs={3}>
                      <Form.Label
                        style={{
                          fontFamily: "Times New Roman",
                          justifyContent: "left",
                          color: "black",
                          fontWeight: "bolder",
                        }}
                      >
                        IGSTAmount
                      </Form.Label>
                    </Col>
                    <Col xs={3}>
                      <Form.Label
                        style={{
                          justifyContent: "left",
                          color: "black",
                          fontWeight: "bolder",
                        }}
                      >
                        :
                      </Form.Label>
                    </Col>
                    <Col>
                      <Form.Label
                        style={{
                          fontFamily: "Times New Roman",
                          justifyContent: "left",
                          color: "red",
                          fontWeight: "bolder",
                        }}
                      >
                        {billsumValues.igstAmt}
                      </Form.Label>
                    </Col>
                  </Row>
                  <Row>
                    <Col xs={3}>
                      <Form.Label
                        style={{
                          fontFamily: "Times New Roman",
                          justifyContent: "left",
                          color: "black",
                          fontWeight: "bolder",
                        }}
                      >
                        TotalBilling Amount
                      </Form.Label>
                    </Col>
                    <Col xs={3}>
                      <Form.Label
                        style={{
                          justifyContent: "left",
                          color: "black",
                          fontWeight: "bolder",
                        }}
                      >
                        :
                      </Form.Label>
                    </Col>
                    <Col>
                      <Form.Label
                        style={{
                          fontFamily: "Times New Roman",
                          justifyContent: "left",
                          color: "red",
                          fontWeight: "bolder",
                        }}
                      >
                        {billsumValues.totalBillAmt}
                      </Form.Label>
                    </Col>
                  </Row>
                </ItemPap1>
              </Grid>
            </Grid>
            <ItemPap1>
              <TableContainer sx={{ height: 290 }} className="mt-1">
                <Table stickyHeader className="table table-bordered">
                  <TableHead>
                    <StyledTableRow>
                      <StyledTableCell>SlNo</StyledTableCell>
                      <StyledTableCell>JobNo {jobnoSrch()}</StyledTableCell>
                      <StyledTableCell>
                        InvoiceNo {invoiceNoSrch()}
                      </StyledTableCell>
                      <StyledTableCell>InvoiceDate</StyledTableCell>
                      <StyledTableCell>
                        ImporterName {impNameSrch()}
                      </StyledTableCell>
                      <StyledTableCell>
                        ForwarderName{forwarderNmSrch()}
                      </StyledTableCell>
                      <StyledTableCell>
                        PartyName{partyNameSrch()}
                      </StyledTableCell>
                      <StyledTableCell>PartyGSTIN</StyledTableCell>
                      <StyledTableCell>
                        PartyState {partystateSrch()}
                      </StyledTableCell>
                      <StyledTableCell>Total_Pkg</StyledTableCell>
                      <StyledTableCell>Gross_WT</StyledTableCell>
                      <StyledTableCell>Chargeable_WT</StyledTableCell>
                      <StyledTableCell>Taxable_Value</StyledTableCell>
                      <StyledTableCell>CGST_Amount</StyledTableCell>
                      <StyledTableCell>SGST_Amount</StyledTableCell>
                      <StyledTableCell>IGST_Amount</StyledTableCell>
                      <StyledTableCell>TotalBillAmount</StyledTableCell>
                      <StyledTableCell>Mode</StyledTableCell>
                      <StyledTableCell>BillPaid_By</StyledTableCell>
                      <StyledTableCell>BillPaid_Date</StyledTableCell>
                      <StyledTableCell>MAWB/MBL</StyledTableCell>
                      <StyledTableCell>HAWB/HBL</StyledTableCell>
                      <StyledTableCell>
                        Container_No{containerSrch()}
                      </StyledTableCell>
                      <StyledTableCell>BOE_No</StyledTableCell>
                      <StyledTableCell>Party_Code</StyledTableCell>
                      <StyledTableCell>Audit_Status</StyledTableCell>
                      <StyledTableCell>Item_Description</StyledTableCell>
                       <StyledTableCell>Assessable value</StyledTableCell>
                    </StyledTableRow>
                  </TableHead>
                  <TableBody>
                    {FilteredDetails.slice(
                      page * rowsPerPage,
                      page * rowsPerPage + rowsPerPage
                    ).map((trns, index) => (
                      <TableRow
                        key={trns.serialNumber}
                        onClick={() => SinglejobsummaryAssign(trns)}
                      >
                        <StyledTableCell
                          style={{ fontSize: "10px", fontWeight: "bold" }}
                        >
                          {trns.serialNumber}
                        </StyledTableCell>
                        <StyledTableCell
                          style={{ fontSize: "10px", fontWeight: "bold" }}
                        >
                          {trns.consignmentId}
                        </StyledTableCell>
                        <StyledTableCell
                          style={{ fontSize: "10px", fontWeight: "bold" }}
                        >
                          {trns.invoiceNo}
                        </StyledTableCell>
                        <StyledTableCell
                          style={{ fontSize: "10px", fontWeight: "bold" }}
                        >
                          {trns.invoiceDate}
                        </StyledTableCell>
                        <StyledTableCell
                          style={{ fontSize: "10px", fontWeight: "bold" }}
                        >
                          {trns.iecName}
                        </StyledTableCell>
                        <StyledTableCell
                          style={{ fontSize: "10px", fontWeight: "bold" }}
                        >
                          {trns.fwdName}
                        </StyledTableCell>
                        <StyledTableCell
                          style={{ fontSize: "10px", fontWeight: "bold" }}
                        >
                          {trns.partyName}
                        </StyledTableCell>
                        <StyledTableCell
                          style={{ fontSize: "10px", fontWeight: "bold" }}
                        >
                          {trns.partyGstin}
                        </StyledTableCell>
                        <StyledTableCell
                          style={{ fontSize: "10px", fontWeight: "bold" }}
                        >
                          {trns.partyStateCode}
                        </StyledTableCell>
                        <StyledTableCell
                          style={{ fontSize: "10px", fontWeight: "bold" }}
                        >
                          {trns.noOfPkg}
                        </StyledTableCell>
                        <StyledTableCell
                          style={{ fontSize: "10px", fontWeight: "bold" }}
                        >
                          {trns.grNetWeight}
                        </StyledTableCell>
                        <StyledTableCell
                          style={{ fontSize: "10px", fontWeight: "bold" }}
                        >
                          {trns.chargableWeight}
                        </StyledTableCell>
                        <StyledTableCell
                          style={{ fontSize: "10px", fontWeight: "bold" }}
                        >
                          {trns.billAmount}
                        </StyledTableCell>
                        <StyledTableCell
                          style={{ fontSize: "10px", fontWeight: "bold" }}
                        >
                          {trns.cgstAmt}
                        </StyledTableCell>
                        <StyledTableCell
                          style={{ fontSize: "10px", fontWeight: "bold" }}
                        >
                          {trns.sgstAmt}
                        </StyledTableCell>
                        <StyledTableCell
                          style={{ fontSize: "10px", fontWeight: "bold" }}
                        >
                          {trns.igstAmt}
                        </StyledTableCell>
                        <StyledTableCell
                          style={{ fontSize: "10px", fontWeight: "bold" }}
                        >
                          {trns.totalBillAmount}
                        </StyledTableCell>
                        <StyledTableCell
                          style={{ fontSize: "10px", fontWeight: "bold" }}
                        >
                          {trns.transitMode}
                        </StyledTableCell>
                        <StyledTableCell
                          style={{ fontSize: "10px", fontWeight: "bold" }}
                        >
                          {trns.billPaidBy}
                        </StyledTableCell>
                        <StyledTableCell
                          style={{ fontSize: "10px", fontWeight: "bold" }}
                        >
                          {trns.billPaidDate}
                        </StyledTableCell>
                        <StyledTableCell
                          style={{ fontSize: "10px", fontWeight: "bold" }}
                        >
                          {trns.mawbNo}
                        </StyledTableCell>
                        <StyledTableCell
                          style={{ fontSize: "10px", fontWeight: "bold" }}
                        >
                          {trns.hawbNo}
                        </StyledTableCell>
                        <StyledTableCell
                          style={{ fontSize: "10px", fontWeight: "bold" }}
                        >
                          {trns.containerNo}
                        </StyledTableCell>
                        <StyledTableCell
                          style={{ fontSize: "10px", fontWeight: "bold" }}
                        >
                          {trns.boeNo}
                        </StyledTableCell>
                        <StyledTableCell
                          style={{ fontSize: "10px", fontWeight: "bold" }}
                        >
                          {trns.partyCode}
                        </StyledTableCell>
                        <StyledTableCell
                          style={{ fontSize: "10px", fontWeight: "bold" }}
                        >
                          {trns.auditStatus}
                        </StyledTableCell>
                        <StyledTableCell
                          style={{ fontSize: "10px", fontWeight: "bold" }}
                        >
                          {trns.itemName}
                        </StyledTableCell>
                            <StyledTableCell
                          style={{ fontSize: "10px", fontWeight: "bold" }}
                        >
                          {trns.assableValue}
                        </StyledTableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
              <TablePagination
                showFirstButton
                showLastButton
                component="div"
                count={FilteredDetails.length}
                rowsPerPage={rowsPerPage}
                page={page}
                onPageChange={handleChangePage}
                onChangeRowsPerpage={handleChangeRowsPerPage}
              />
            </ItemPap1>
          </ItemPap>
        )}
      </div>
    </div>
  );
}

export default BillSummaryReport;
